<script lang="ts">
    import { getContext } from 'svelte';

    let vertical = getContext<{ current: 'casino' | 'sports' }>('vertical');

    vertical.current = 'sports';
    let { children } = $props();
</script>

{@render children()}
